function loadPojo() {
  if (!window.pojoLoaded) {
    window.pojoLoaded = true;
    window.PojoA11yOptions = {"focusable":"","remove_link_target":"","add_role_links":"1","enable_save":"1","save_expiration":"12"};
    $.getScript('/wp-content/plugins/pojo-accessibility/modules/legacy/assets/js/app.min.js?ver=1.0.0');
    $('head').append('<link rel="stylesheet" as="style" crossorigin="anonymous" href="/wp-content/plugins/pojo-accessibility/modules/legacy/assets/css/style.min.css?ver=1.0.0" media="all" />');
  }
}


window.addEventListener('load', (event) => {
  const dropdownBtn = document.querySelectorAll(".menu .dropdown-btn");
  const dropdown = document.querySelectorAll(".menu .dropdown");
  const hamburgerBtn = document.getElementById("hamburger");
  const closeMenuBtn = document.getElementById("closeMenu");
  const navMenu = document.querySelector(".menu");
  const menuBar = document.querySelector(".menu-bar");
  const links = document.querySelectorAll(".menu .dropdown a");
  const bodyElem = document.querySelector("body");
  const htmlElem = document.querySelector("html");
  const mainWrapper = document.querySelector(".main-wrapper");

  window.pojoLoaded = false;

  function setAriaExpandedFalse() {
    dropdownBtn.forEach((btn) => btn.setAttribute("aria-expanded", "false"));
  }

  function closeDropdownMenu() {
    dropdown.forEach((drop) => {
      drop.classList.remove("active");
      drop.addEventListener("click", (e) => e.stopPropagation());
    });

    menuBar.classList.remove("overflow");
  }

  function toggleHamburger() {
    if(navMenu.classList.contains('show')) {
      mainWrapper.classList.remove("block-scroll");
      if(typeof(mainWrapper.dataset.frozenScroll) !== 'undefined') {
        htmlElem.scrollTop = mainWrapper.dataset.frozenScroll;
        delete mainWrapper.dataset.frozenScroll;
      }
      navMenu.classList.remove("show");
      hamburgerBtn.classList.remove("active");
      bodyElem.classList.remove("opened-menu");
    } else {
      mainWrapper.dataset.frozenScroll = htmlElem.scrollTop;
      navMenu.classList.add("show");
      hamburgerBtn.classList.add("active");
      bodyElem.classList.add("opened-menu");
      mainWrapper.classList.add("block-scroll");
    }
  }

  function toggleDropDown(btn, e) {
    const dropdownIndex = e.currentTarget.dataset.dropdown;
    const dropdownElement = document.getElementById(dropdownIndex);

    menuBar.classList.add("overflow");
    dropdownElement.classList.toggle("active");
    dropdown.forEach((drop) => {
      if (drop.id !== btn.dataset["dropdown"]) {
        drop.classList.remove("active");
      }
    });
    e.stopPropagation();
    btn.setAttribute(
            "aria-expanded",
            btn.getAttribute("aria-expanded") === "false" ? "true" : "false"
            );
  }


  dropdownBtn.forEach((btn) => {


    btn.addEventListener("click", function (e) {
      if (window.innerWidth < 992) {
        toggleDropDown(btn, e);
      }
    });
  });

// close dropdown menu when the dropdown links are clicked
  links.forEach((link) =>
    link.addEventListener("click", () => {
      closeDropdownMenu();
      setAriaExpandedFalse();
      toggleHamburger();
    })
  );

// close dropdown menu when you click on the document body
  document.documentElement.addEventListener("click", () => {
    closeDropdownMenu();
    setAriaExpandedFalse();
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth >= 992) {
      loadPojo();
    }
  });
  document.addEventListener("scroll", () => {
    if (window.innerWidth >= 992) {
      closeDropdownMenu();
      setAriaExpandedFalse();
    }
  });

// close dropdown when the escape key is pressed
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeDropdownMenu();
      setAriaExpandedFalse();
    }
  });

// toggle hamburger menu
  hamburgerBtn.addEventListener("click", toggleHamburger);
  closeMenuBtn.addEventListener("click", toggleHamburger);
});
$(document).ready(function () {
  $(window).one('scroll touchstart mouseenter', function () {
    if (window.innerWidth >= 992) {
      loadPojo();
    }
  });

  function stickyHeader() {
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
      $("body").addClass("sticky-header");
    } else {
      $("body").removeClass("sticky-header");
    }
  }
  stickyHeader();
  
  $(window).on('scroll', function () {
    stickyHeader();
  });

  function showSearchBar() {
    $('.search-box').addClass('open').parents().addClass('overlay');
    $('.search-box').find('input[type=search]').focus();
  }

  function hideSearchBar() {
    $(".search-box").data("formopen", 0);
    $('.search-box').removeClass('open').parents().removeClass('overlay');
  }

  $('button.btn-search').on('click', function () {
    if ($(".search-box").data("formopen") === 1) {
      $('form.search-form').submit();
      return false;
    } else {
      $(".search-box").data("formopen", 1);
      if ($('.menu-toggle').hasClass("opened") && $(window).width() < 1200) {
        hideNav();
      }
      showSearchBar();
    }
  });
  $('.ai-bot').click(function () {
    $(this).removeClass('show-bouble').addClass('no-pulse');
    window.dataLayer.push({'event': 'intercomLoaderClick'});
  });
});

window.addEventListener("OneTrustGroupsUpdated", function (event) {
  if (event.detail.includes("C0004")) {
    document.body.classList.add('ai-bot-launcher');
    if (sessionStorage.getItem('visited') !== 'true') {
      setTimeout(function () {
        if ((intercomLauncher = document.querySelector(".ai-bot")) !== null) {
          intercomLauncher.classList.add('show-bouble');
        }
        setTimeout(function () {
          sessionStorage.setItem('visited', 'true');
          if ((intercomLauncher = document.querySelector(".ai-bot")) !== null) {
            intercomLauncher.classList.remove('show-bouble');
          }
        }, 10000);
      }, 4000);
    }
  }
});
